<template>
  <div v-loading="loading" class="chart-box">
    <div class="chart-box-item">
      <v-chart class="chart-box-control" :options="chartType" />
      <div class="total">
        <div class="label">总任务数</div>
        <div class="num">{{ total }}件</div>
      </div>
    </div>
    <div class="chart-box-item">
      <v-chart class="chart-box-control" :options="chartArea" />
      <div class="total">
        <div class="label">总任务数</div>
        <div class="num">{{ total }}件</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import ECharts from 'vue-echarts';
Vue.component('v-chart', ECharts);
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/legendScroll';
export default {
  props: ['form'],
  data() {
    let chart = {
      title: {
        left: 130,
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
      },
      legend: {
        data: [],
        type: 'scroll',
        orient: 'vertical',
        right: 0,
        top: 30,
      },
      series: {
        name: '任务',
        type: 'pie',
        radius: ['50%', '70%'],
        center: ['40%', '50%'],
        data: [],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    };
    return {
      loading: false,
      total: 0,
      chartType: {
        title: { text: '任务类型占比', ...chart.title },
        tooltip: chart.tooltip,
        legend: {
          ...Object.assign({}, chart.legend),
          formatter: (name) => {
            let data = this.chartType.series[0].data.filter((item) => item.name == name)[0];
            return `${name} | ${data.pct}% ${data.value}件`;
          },
        },
        series: [Object.assign({}, chart.series)],
      },
      chartArea: {
        title: { text: '各区域任务占比', ...chart.title },
        tooltip: chart.tooltip,
        legend: {
          ...Object.assign({}, chart.legend),
          data: [],
          formatter: (name) => {
            let data = this.chartArea.series[0].data.filter((item) => item.name == name)[0];
            return `${name} | ${data.pct}% ${data.value}件`;
          },
        },
        series: [Object.assign({}, chart.series)],
      },
    };
  },

  created() {
    this.getList();
  },

  methods: {
    //获取任务类型数据
    async getList() {
      this.loading = true;
      try {
        let res = await this.api.basic.analyse(this.form);
        this.total = res.data.count;
        this.chartType.series[0].data = res.data.arrType;
        this.chartType.legend.data = res.data.arrType.map((item) => item.name);
        this.chartArea.series[0].data = res.data.arrArea;
        this.chartArea.legend.data = res.data.arrArea.map((item) => item.name);
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.chart-box {
  display: flex;
  flex-shrink: 0;
  margin-top: 30px;
}
.chart-box .chart-box-item {
  flex: 1;
  position: relative;
}
.chart-box .chart-box-control {
  width: 100%;
  height: 400px;
}
.chart-box .total {
  position: absolute;
  left: 33.5%;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 17px;
}
</style>
